import { connect } from 'react-redux';
import StreamingsFormView from './index'
import {updateStreaming, loadStreamings, saveStreaming} from '../../actions/Streamings'


const mapStateToProps = (state, props) => {
    
    return {

    }
}

const mapDispatchToProps = (dispatch, state) => {
  
    return {
	saveStreaming: (data) => {
	    return dispatch(saveStreaming(data)).then(() =>  dispatch(loadStreamings()))
	},
	updateStreaming: (data) => {
	    return dispatch(updateStreaming(data)).then(() =>  dispatch(loadStreamings()))
	}
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StreamingsFormView);






// WEBPACK FOOTER //
// ./src/components/StreamingsForm/Container.js